import React from 'react'

export function ReorderDaysOfWeek (sequence: number, type: string | undefined) {
  const SUNDAY_IS = 7
  if (type === 'WEEKDAYS') {
    return (sequence === 1 ? SUNDAY_IS : sequence - 1)
  }
  return sequence
}
